// src/app/services/kaiSizerApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { UpdatePayload } from '../models';

export const kaiSizerApi = createApi({
  reducerPath: 'kaiSizerApi',
  baseQuery,
  endpoints: (builder) => ({
    getOptimalSizes: builder.query<any[], void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/dynamic_sizer/optimal_sizes/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getSizerMatrixData: builder.mutation<any, UpdatePayload<any>>({
      query: ({ body, signal }) => ({
        url: `/api/v1.0/rpc/sizer_matrix_data/`,
        method: 'POST',
        body,
        signal,
      }),
    }),
  }),
});

export const {
  useGetOptimalSizesQuery,
  useLazyGetOptimalSizesQuery,
  useGetSizerMatrixDataMutation,
} = kaiSizerApi;

